import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'
import { ImageToVideoForm } from '@/components/features/video'
import { AnalyticsService } from '@/services/analytics'

export function ImageToVideoPage() {
  const { user } = useUser()

  useEffect(() => {
    AnalyticsService.trackViewItem('video_tools', 'image_to_video', 'Image to Video', user?.id)
    AnalyticsService.trackViewContent('Image to Video', user?.id)
  }, [user?.id])

  return (
    <div className="p-6 md:p-8 max-w-4xl mx-auto">
      <ImageToVideoForm />
    </div>
  )
}
